// extracted by mini-css-extract-plugin
export default {"picture":"Picture_picture__4EArM","cover":"Picture_cover__BABsC"};